import React from 'react';
import { withApollo } from "react-apollo";
import { NavLink } from 'react-router-dom';

import { query2State } from '../../util';

import { updateUser } from '../../graphql/mutations';
import { user } from '../../graphql/queries';
import { ColHead } from '../chunk'

class UserEdit extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      name: '',  
      email: '',
      avatar: '',
      description: '',
      birthday: '',
      phone: ''
    };

    this.mutate = this.mutate.bind(this);
  }

  componentDidMount(){
    this.props.client.query({
      query: user,
      variables: { id: this.props.match.params.id }
    })
    .then(res => {
      console.log('OK!', res);
      this.setState(query2State(res.data.user));
    })
    .catch(e => {
      alert('User Fetch Error: ' + e);
    });
  }

  mutate(e) {

    const { id, name, phone, email, description, birthday } = this.state;

    this.props.client.mutate({
      mutation: updateUser,
      variables: { id, name, phone, email, description, birthday }
    })
    .then(res => {
      alert('OK!');
    })
    .catch(e => {
      alert('User Edit Error: ' + e);
    });
  }
	
	render() {

		/*let { loading, error, user } = this.props.data;
		if( loading ) return (<div className="col col-2"><ColLoading /></div>)
    if( error ) return (<div className="col col-2"><ColError error={error} /></div>)
*/
    const dateBirth = this.state.birthday ? new Date(this.state.birthday).toISOString().split('T')[0] : '';

		return (
      		<div className="col col-2" key={user.id}>
            <ColHead title="USER EDIT" />

            <div className="avatar avatar--large" style={{backgroundImage: `url(/avatare/${this.state.avatar})`}}></div>
            <p style={{textAlign:'center', marginBottom: '2rem'}}>{user.name}</p>

            <form onSubmit={(e) => e.preventDefault() }>
              <label className="label" htmlFor="phone">Fon</label>
              <input id="phone" className="input" type="text" placeholder="+49 144 844 3444" value={this.state.phone} onChange={e => this.setState({phone: e.target.value})} />

              <label className="label" htmlFor="email">E-Mail</label>
              <input id="email" className="input" type="email" placeholder="user@example.net" value={this.state.email} onChange={e => this.setState({email: e.target.value})} />

              <label className="label" htmlFor="birthday">Geburtstag</label>
              <input id="birthday" className="input" type="date" 
              value={dateBirth} onChange={e => this.setState({birthday: e.target.value})} />

              <div className="button-wrap">
                <NavLink className="button button--secondary" to={`/users/${this.state.id}`}>cancel</NavLink>
                <button onClick={this.mutate} className="button button--submit">save</button>
              </div>
            </form>
      		</div>
      	)
	}
}

export default withApollo(UserEdit)


// WEBPACK FOOTER //
// ./src/components/user/UserEdit.js